export const NON_BREAKING_SPACE = '\u00A0'
